var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCopyLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 5.00008V2.50008C5.83317 2.03985 6.20627 1.66675 6.6665 1.66675H16.6665C17.1267 1.66675 17.4998 2.03985 17.4998 2.50008V14.1667C17.4998 14.627 17.1267 15.0001 16.6665 15.0001H14.1665V17.4993C14.1665 17.96 13.7916 18.3334 13.3275 18.3334H3.33888C2.87549 18.3334 2.5 17.9629 2.5 17.4993L2.50217 5.83414C2.50225 5.37351 2.8772 5.00008 3.34118 5.00008H5.83317ZM4.16868 6.66675L4.16682 16.6667H12.4998V6.66675H4.16868ZM7.49983 5.00008H14.1665V13.3334H15.8332V3.33341H7.49983V5.00008Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopyLine);
export default __webpack_public_path__ + "static/media/file-copy-line.11cec372a55e8b174577ee2899a7018f.svg";
export { ForwardRef as ReactComponent };